<template>
  <div class="advantageTrain">
    <div class="colorTitle firstTitle">
      <span>///</span> 培训赋能——线下 <span>///</span>
    </div>
    <div class="orangeTitle fz16">代理人在销售端成长周期内，培训体系分为创业期、成长期、成熟期。</div>
    <div class="compText">
      创业期由团队MDRT讲师手把手教授12个技术模块，培训形式涵盖COP、启星班、育星班，通过90天的职业早期训练帮助新代理人快速融入团队，达成至尊峰会标准。成长期代理人将定期参与星辉班培训，达成掌握经营触点分析法、研修销售场景及流程、强化需求、案例训练、提升经营效率、签约效率的培训目标，达成行业MDRT业务标准。
      成熟期代理人将进入公司专属成长计划，重点参加代理人教练训练团、研讨高净值客户经营方法论、考取全能理财师、尝试打造个人IP，挑战TOT等更高业务目标。
    </div>
    <div>
      <img class="imgPicture_48" src="../assets/images/picture_48.png" alt="">
    </div>
    <div class="orangeTitle fz16" style="margin-top:70px;">事务所管理端的培训赋能分为，星火合伙人筹备培训、星主管基础培训、星卓越提升培训。</div>
    <!-- <div class="colorTitle firstTitle">
      <span>///</span> 成长赋能体系 <span>///</span>
    </div> -->
    <div class="compText">
      星火合伙人筹备培训，针对星火事务所合伙人的特色和事务所发展规划开展三个月的培训咨询。培训的形式为每周一次线上事务所组会，每月一次线下训练、研讨，根据事务所筹备关键节点安排一对一定制培训辅导。
    </div>
    <div>
      <img class="imgPicture_45" src="../assets/images/picture_45.png" alt="">
      <!-- <img src="../assets/images/picture_11.png" alt=""> -->
    </div>
    <!-- <div class="colorTitle">
      <span>///</span> 领袖培养计划 <span>///</span>
    </div>
    <div class="compText">我们投入了长达六年、价值千万的行业顶尖资源，梳理了精英顾问成长的阶段和路径，规划了与之匹配的荣誉体系，引导优秀顾问成为行业精英。</div>
    <div>
      <img src="../assets/images/picture_12.png" alt="">
    </div>
    <div class="colorTitle">
      <span>///</span> 荣誉体系 <span>///</span>
    </div>
    <div>
      <img src="../assets/images/picture_13.png" alt="">
    </div> -->
    <div class="colorTitle firstTitle">
      <span>///</span> 培训赋能——线上 <span>///</span>
    </div>
    <div class="compText">
      鲸云保线上培训不仅制作、引进了大量与业务场景匹配的课程内容，满足代理人碎片化的学习提升需求，同时实现了线上、线下的学习联动，线上课程与线下训练贯通一体，创造了良好的学习体验，形成线上标准化课程系列。
    </div>
    <div>
      <img class="imgPicture_46" src="../assets/images/picture_46.png" alt="" />
    </div>


  </div>
</template>

<script>
export default {
  name: 'advantageTrain',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.advantageTrain {
  width: 1024px;
  margin: 0 auto;
  text-align: justify;

  .firstTitle {
    margin-top: 0 !important;
  }

  .compText {
    margin-top: 10px !important;
  }

  .imgPicture_45 {
    margin: 50px auto;
    display: block;
    width: 557px;
  }

  .orangeTitle {
    color: #2488CA;
    font-weight: bold;
  }

  .imgPicture_46 {
    margin: 50px auto;
    display: block;
    width: 557px;
  }

  .imgPicture_48 {
    margin: 50px auto;
    display: block;
    width: 830px;
  }

  &>div {
    margin-top: 40px;
    position: relative;

    .ideaText {
      width: 100%;
      color: #ffffff;
      position: absolute;
      top: 80px;
      text-align: center;

      &>div:first-child {
        font-weight: 600;
      }
    }

    img {
      width: 100%;
    }
  }
}
</style>